import { render, staticRenderFns } from "./UnusedWords.vue?vue&type=template&id=554af14a&scoped=true"
import script from "./UnusedWords.vue?vue&type=script&lang=js"
export * from "./UnusedWords.vue?vue&type=script&lang=js"
import style0 from "./UnusedWords.vue?vue&type=style&index=0&id=554af14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554af14a",
  null
  
)

export default component.exports